const Yonetim = resolve => {
    require.ensure(['../views/apps/yonetim/Yonetim'], () => {
        resolve(require('../views/apps/yonetim/Yonetim'))
    })
};
const YonetimDetay = resolve => {
    require.ensure(['../views/apps/yonetim/YonetimDetay'], () => {
        resolve(require('../views/apps/yonetim/YonetimDetay'))
    })
};

import Vue from 'vue'
Vue.component('YonetimDetay', YonetimDetay);
import layouts from '../layout'

export default {
    path: '/yonetim',
    name: 'yonetim',
    component: Yonetim,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: '/detay',
            name: 'yonetimdetay',
            component: YonetimDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
